import { render, staticRenderFns } from "./musicDetail.vue?vue&type=template&id=da251422&scoped=true&"
import script from "./musicDetail.vue?vue&type=script&lang=js&"
export * from "./musicDetail.vue?vue&type=script&lang=js&"
import style0 from "./musicDetail.vue?vue&type=style&index=0&id=da251422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da251422",
  null
  
)

export default component.exports